import { Button1, Checkbox, Select } from "../index";
import MainLayout from "../../layout/MainLayout";
import { useNavigate } from "react-router-dom";
import { accountsApi } from "../../api/endpoints";
import searchIcon from "../../assets/icons/search-icon.png";
import americanExpressLogo from "../../assets/images/american-express-icon.png";
import anzLogo from "../../assets/images/anz-logo.png";
import queenslandLogo from "../../assets/images/queenslandbank-logo.png";
import bankwestLogo from "../../assets/images/bankwest-logo.png";
import ingLogo from "../../assets/images/ing-logo.png";
import georgebankLogo from "../../assets/images/georgebank-logo.png";
import westpacLogo from "../../assets/images/westpac-logo.png";
import ampLogo from "../../assets/images/amp-logo.png";
import melbournebankLogo from "../../assets/images/melbournebank-logo.png";
import sabankLogo from "../../assets/images/sabank-logo.png";
import commonwealthbankLogo from "../../assets/images/commonwealthbank-logo.png";
import nabinternetLogo from "../../assets/images/nabInternet-logo.png";
import suncorpLogo from "../../assets/images/suncorp-logo.png";
import plusIcon from "../../assets/icons/plus-icon.png";
import minusIcon from "../../assets/icons/minus-icon.png";
import { Input } from "antd";
import { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import QuickActionSelect from "../quick-action-select/QuickActionSelect";

const ConnectNewAccount = () => {
  const [showSelectedFAQ, setShowSelectedFAQ] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [creating, setCreating] = useState(false);
  const [currency, setCurrency] = useState("AUD");
  const [createdAccount, setCreatedAccount] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { user } = useAuth();
  const isKycVerified = user?.kycStatus === "VERIFIED";

  const currencyOptions = [
    { name: "AUD, Australian Dollar", value: "AUD" },
    { name: "USD, US Dollar", value: "USD" },
    { name: "EUR, Euro", value: "EUR" },
    { name: "GBP, British Pound", value: "GBP" },
    { name: "PKR, Pakistani Rupee", value: "PKR" },
    { name: "INR, Indian Rupee", value: "INR" },
    { name: "CAD, Canadian Dollar", value: "CAD" },
    { name: "CNY, Chinese Yuan", value: "CNY" },
  ];

  const handleCreate = async () => {
    setCreating(true);
    setError(null);
    try {
      const account = await accountsApi.create({ currency });
      setCreatedAccount(account);
    } catch (err) {
      setError(err.response?.data?.error || err.message || "Failed to create account");
    } finally {
      setCreating(false);
    }
  };
  const choicesDetails = [
    {
      name: "American Express",
      icon: americanExpressLogo,
    },
    {
      name: "ANZ",
      icon: anzLogo,
    },
    {
      name: "Bank of Queensland",
      icon: queenslandLogo,
    },
    {
      name: "BankWest",
      icon: bankwestLogo,
    },
    {
      name: "ING",
      icon: ingLogo,
    },
    {
      name: "St. George Bank",
      icon: georgebankLogo,
    },
    {
      name: "Westpac",
      icon: westpacLogo,
    },
    {
      name: "AMP",
      icon: ampLogo,
    },
    {
      name: "Bank of Melbourne",
      icon: melbournebankLogo,
    },
    {
      name: "BankSA",
      icon: sabankLogo,
    },
    {
      name: "Commonwealth Bank",
      icon: commonwealthbankLogo,
    },
    {
      name: "NAB Internet",
      icon: nabinternetLogo,
    },
    {
      name: "Suncorp",
      icon: suncorpLogo,
    },
  ];
  const faqs = [
    {
      question: "FAQs related to connecting a new account",
      answer: (
        <>
          <span>
            Creating a wallet opens a currency account in ARM Financial for the
            selected currency. It is available immediately once your KYC status
            allows wallet creation.
          </span>
          <span>
            External bank institution search is shown only to help choose the
            funding source. Actual wallet creation is submitted through the ARM
            Financial backend and no sample wallet is created on the frontend.
          </span>
        </>
      ),
    },
    {
      question: "Why do I need to give my credentials?",
      answer: (
        <>
          <span>
            Bank credentials are only needed when you choose to link an external
            bank account for funding. They are not required for creating a new
            ARM Financial currency wallet.
          </span>
          <span>
            The direct-debit funding flow stores linked bank account metadata in
            the backend and masks account numbers in the UI.
          </span>
        </>
      ),
    },
    {
      question:
        "How can I remove the authority I have given to connect accounts?",
      answer: (
        <>
          <span>
            Linked funding bank accounts can be removed from the direct-debit
            source selector. Removing a funding source stops it being offered
            for new top-ups.
          </span>
          <span>
            Existing wallet balances and completed transactions remain visible
            in your wallet history.
          </span>
        </>
      ),
    },
    {
      question: "How long does the connection authority last?",
      answer: (
        <>
          <span>
            A funding source remains available until you remove it or ARM
            Financial marks it unavailable for compliance, account status, or
            provider reasons.
          </span>
          <span>
            KYC-sensitive actions remain blocked until the backend profile
            reports an eligible verification status.
          </span>
        </>
      ),
    },
  ];

  const onShow = (key) => {
    if (showSelectedFAQ[key]) {
      setShowSelectedFAQ({ ...showSelectedFAQ, [key]: false });
    } else {
      setShowSelectedFAQ({ ...showSelectedFAQ, [key]: true });
    }
  };
  return (
    <>
      <MainLayout
        NavName="My Accounts"
        expand={false}
        pageClassName="dashboard-page finance-action-page connect-account-page"
        contentClassName="dashboard-content"
      >
        <div className="finance-action-shell">
            <div className="finance-action-overview">
              <div>
                <span className="dashboard-eyebrow">Account connection</span>
                <h2>Connect New Account</h2>
                <p>Search institutions, connect bank credentials, or create a new multi-currency wallet.</p>
              </div>
              <QuickActionSelect className="change-down-icon-white" />
            </div>

            <div className="finance-action-card row justify-content-between p-3 mt-4">
              <div className="col-lg-5">
                <div className="d-flex flex-column gap-3">
                  <span className="fs-5 fw-medium">Search Institution</span>

                  <div className="d-flex flex-column gap-2">
                    <Input
                      className="p-3 "
                      placeholder="Search institutions"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      prefix={
                        <img
                          src={searchIcon}
                          alt="search"
                          width={16}
                          height={16}
                        />
                      }
                    />
                    <span
                      className="fs12px fw-medium"
                      style={{ color: "#7D7D7D" }}
                    >
                      Or choose from the following popular choices
                    </span>
                  </div>

                  <div className="d-flex flex-column gap-2">
                    {choicesDetails
                      .filter(({ name }) =>
                        name.toLowerCase().includes(searchQuery.toLowerCase())
                      )
                      .map(({ name, icon }, key) => (
                        <div
                          key={key}
                          className="d-flex align-items-center gap-2"
                        >
                          <img src={icon} alt={name.toLowerCase()} />
                          <span>{name}</span>
                        </div>
                      ))}
                    {choicesDetails.filter(({ name }) =>
                      name.toLowerCase().includes(searchQuery.toLowerCase())
                    ).length === 0 && (
                      <span
                        className="fs12px fw-medium"
                        style={{ color: "#7D7D7D" }}
                      >
                        No institutions match "{searchQuery}"
                      </span>
                    )}
                    <Checkbox>Include international services</Checkbox>
                  </div>

                  <div className="d-flex flex-column gap-2 mt-3">
                    <span className="fs14 fw-semibold">Enter Credentials</span>
                    <div className="d-flex align-items-center gap-3">
                      <img src={ampLogo} alt="amp" width={25} height={25} />
                      <div className="d-flex flex-column ">
                        <span>AMP</span>
                        <span className="fs12px" style={{ color: "#7D7D7D" }}>
                          Australia
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="d-flex flex-column gap-2">
                    <label className="fs12px ">Username</label>
                    <Input className="p-3" placeholder="Type your username" />
                  </div>

                  <div className="d-flex flex-column gap-2">
                    <label className="fs12px ">Password</label>
                    <Input className="p-3" placeholder="Type your password" />
                  </div>

                  <div>
                    <span
                      className="fs12px fw-semibold "
                      style={{ color: "#7D7D7D" }}
                    >
                      We protect your information using 256-bit encryption,
                      equivalent to that used by banks.{" "}
                      <span
                        style={{ color: "#1bbb6b" }}
                        className="cursor-pointer"
                      >
                        Read More
                      </span>
                    </span>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="d-flex flex-column gap-3">
                  <span className="fs-5 fw-medium">Notes Information</span>
                  {faqs.map(({ question, answer }, key) => (
                    <div key={key} className="d-flex flex-column gap-3">
                      <div className="d-flex justify-content-between align-items-center gap-4">
                        <span className=" fw-medium">{question}</span>
                        <img
                          src={showSelectedFAQ[key] ? minusIcon : plusIcon}
                          alt={showSelectedFAQ[key] ? "See less" : "See more"}
                          className="cursor-pointer"
                          onClick={() => onShow(key)}
                        />
                      </div>

                      {showSelectedFAQ[key] && (
                        <div
                          className="fs14px fw-medium d-flex gap-3 flex-column"
                          style={{ color: "#7d7d7d" }}
                        >
                          {answer}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>

              {/* Create New Wallet is hidden for now (multi-currency wallets not
                  live yet). Re-enable this block when Mobile Wallet ships.
              <div className="col-12 mt-3">
                <div className="d-flex flex-column gap-3 border rounded-3 p-3">
                  <span className="fs-5 fw-medium">Create New Wallet</span>
                  <span className="fs12px" style={{ color: "#7D7D7D" }}>
                    Instantly create a multi-currency wallet with its own IBAN.
                  </span>
                  {!isKycVerified && (
                    <span className="fs12px fw-semibold" style={{ color: "#F7A64F" }}>
                      Complete your KYC verification to create new wallets.
                    </span>
                  )}
                  <div className="d-flex gap-2 align-items-center flex-wrap">
                    <label className="fs12px fw-medium">Currency</label>
                    <Select
                      defaultValue={currency}
                      className="rounded-pill"
                      options={currencyOptions}
                      selectStyle={{ width: "240px" }}
                      onChange={(e) => setCurrency(e.target.value)}
                    />
                    <Button1
                      buttonName={creating ? "Creating..." : "Create Wallet"}
                      className="btn-dark"
                      onClick={handleCreate}
                      disabled={creating || !isKycVerified}
                    />
                  </div>
                  {error && (
                    <span className="fs12px" style={{ color: "#FC555B" }}>
                      {error}
                    </span>
                  )}
                  {createdAccount && (
                    <div
                      className="d-flex flex-column gap-1 p-3 rounded-3"
                      style={{ background: "#E9FBF3", border: "1px solid #1BBB6B" }}
                    >
                      <span className="fs14px fw-semibold" style={{ color: "#0E2C24" }}>
                        Wallet created
                      </span>
                      <span className="fs12px">
                        IBAN: <code>{createdAccount.iban ? `••••••${createdAccount.iban.slice(-4)}` : "-"}</code>
                      </span>
                      <span className="fs12px">
                        BIC: <code>{createdAccount.bic}</code> Sort code: <code>{createdAccount.sortCode}</code>
                      </span>
                      <span className="fs12px">
                        Currency: <code>{createdAccount.currency}</code>
                      </span>
                    </div>
                  )}
                </div>
              </div>
              */}
              <div className="d-flex justify-content-md-end aliign-items-center mt-4 justify-content-center gap-2">
                <Button1
                  buttonName={"Back to Wallet"}
                  className={"border"}
                  onClick={() => navigate("/wallet")}
                />
                <Button1
                  buttonName={"Continue"}
                  className={"btn-dark"}
                  onClick={() => navigate("/wallet")}
                />
              </div>
            </div>
        </div>
      </MainLayout>
    </>
  );
};

export default ConnectNewAccount;
